export enum CRONJOBS {
  "FETCH_SALES" = 'fetchSales',
  "REPROCESS_ORDERS" = 'processOrder'
};
